<script setup>
// Serve la const props per poter usare listaServizi in setup
// defineProps senza la reference della const non permette di usare le props in setup
const props = defineProps({
  listaServizi: {
    type: Array,
    default: () => [],
  },
})

const analizzaItems = computed(() =>
  props.listaServizi.filter(
    (item) => item && item.suddivisioneServizioMenu === 'analizza',
  ),
)
const digitalizzaItems = computed(() =>
  props.listaServizi.filter(
    (item) => item && item.suddivisioneServizioMenu === 'digitalizza',
  ),
)
const mettiANormaItems = computed(() =>
  props.listaServizi.filter(
    (item) => item && item.suddivisioneServizioMenu === 'metti-a-norma',
  ),
)
</script>

<template>
  <div class="p-top-7 p-bot-1">
    <div class="row-400-20 servizi-list max">
      <div class="column-1">
        <div v-if="analizzaItems.length > 0">
          <h2 class="heading-2 title">Analizza</h2>
          <div
            v-for="(item, index) in analizzaItems"
            :key="'analizza-' + index"
            class="servizio"
            :class="[
              'servizio',
              { 'last-item': index === analizzaItems.length - 1 },
            ]"
          >
            <nuxt-link
              v-if="item.slug"
              class="text-4"
              :to="
                $localePath({
                  name: 'servizi-slug',
                  params: { slug: item.slug },
                })
              "
            >
              <div class="icon-link-animation">
                <div v-if="item.titolo" class="text">
                  {{ item.titolo }}
                </div>
                <div class="icon-container">
                  <div class="icon">
                    <img src="@/assets/img/ico/arrows.svg" alt="Icon" />
                  </div>
                  <div class="icon-hover">
                    <img src="@/assets/img/ico/arrows-color3.svg" alt="Icon" />
                  </div>
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
        <div v-if="digitalizzaItems.length > 0">
          <h2 class="heading-2 title last">Digitalizza</h2>
          <div
            v-for="(item, index) in digitalizzaItems"
            :key="'digitalizza-' + index"
            class="servizio"
            :class="[
              'servizio',
              { 'last-item': index === digitalizzaItems.length - 1 },
            ]"
          >
            <nuxt-link
              v-if="item.slug"
              class="text-4"
              :to="
                $localePath({
                  name: 'servizi-slug',
                  params: { slug: item.slug },
                })
              "
            >
              <div class="icon-link-animation">
                <div v-if="item.titolo" class="text">
                  {{ item.titolo }}
                </div>
                <div class="icon-container">
                  <div class="icon">
                    <img src="@/assets/img/ico/arrows.svg" alt="Icon" />
                  </div>
                  <div class="icon-hover">
                    <img src="@/assets/img/ico/arrows-color3.svg" alt="Icon" />
                  </div>
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
      <div v-if="mettiANormaItems.length > 0" class="column-2">
        <h2 class="heading-2 title">Metti a norma</h2>
        <div
          v-for="(item, index) in mettiANormaItems"
          :key="'metti-a-norma-' + index"
          class="servizio"
          :class="[
            'servizio',
            { 'last-item': index === mettiANormaItems.length - 1 },
          ]"
        >
          <nuxt-link
            v-if="item.slug"
            class="text-4"
            :to="
              $localePath({
                name: 'servizi-slug',
                params: { slug: item.slug },
              })
            "
          >
            <div class="icon-link-animation">
              <div v-if="item.titolo" class="text">
                {{ item.titolo }}
              </div>
              <div class="icon-container">
                <div class="icon">
                  <img src="@/assets/img/ico/arrows.svg" alt="Icon" />
                </div>
                <div class="icon-hover">
                  <img src="@/assets/img/ico/arrows-color3.svg" alt="Icon" />
                </div>
              </div>
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiziList',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
